const summaryReducer=function(state={metricFunction:[],metricGlobal:[],property:[],question:[],chartValues:[], chart: null, propertyDisp: []},action){
    switch(action.type){
        case "GET_DATA":
            return {...state,metricGlobal:action.payload.metric?[...JSON.parse(action.payload.metric)]:[],metricFunction:action.payload.metricFunction?[...JSON.parse(action.payload.metricFunction)]:[],property:action.payload.property?[...JSON.parse(action.payload.property)]:[],question:action.payload.question?[...JSON.parse(action.payload.question)]:[]}
        case "GET_INITIAL_DATA":
            if(action.payload.chartValues){
                var propertyDisp=JSON.parse(action.payload.property)?JSON.parse(action.payload.property):[];
                return {...state,chartValues:[...JSON.parse(action.payload.chartValues)], chart: action.payload.chart, propertyDisp: propertyDisp}
            }
            else{
                return {...state}
            }
        default:
            return state;
    }
}
export default summaryReducer;